import { TranslationMatrix } from "../matrixCalculator/types";
import { useState } from "react";
import { produce } from "immer";
import { isFloat } from "./utils";

type ErrorsMap = [string, string, string, string, string, string];
type MatrixField = string;
type MatrixInput = [
  MatrixField,
  MatrixField,
  MatrixField,
  MatrixField,
  MatrixField,
  MatrixField,
];

const getTranslationMatrix = (input: MatrixInput) => {
  let hasNan = false;
  const nums = input.map((v) => {
    if (!isFloat(v)) {
      hasNan = true;
    }
    return parseFloat(v);
  });
  if (hasNan) {
    return undefined;
  }
  return nums;
};

export const isValidInput = (input: MatrixInput) => {
  if (input.join("") == "") {
    return true;
  }
  return !!getTranslationMatrix(input);
};

export interface MatrixState {
  resetMatrix: () => void;
  setMatrixValue: (index: number, value: string) => void;
  matrix: MatrixInput;
  errors: ErrorsMap;
  translationMatrix: TranslationMatrix | undefined;
  setTranslationMatrix: (tm: TranslationMatrix | undefined) => void;
  isValidMatrixInput: boolean;
}

export const useMatrixState = (): MatrixState => {
  const [errors, setErrors] = useState<ErrorsMap>(["", "", "", "", "", ""]);
  const [matrix, setMatrix] = useState<MatrixInput>(["", "", "", "", "", ""]);

  const setMatrixValue = (index: number, value: string) => {
    const errorMessage = !isFloat(value) ? "Not a number" : "";
    const newErrors: ErrorsMap = produce(errors, (draft) => {
      draft[index] = errorMessage;
    });
    setErrors(newErrors);

    const newMatrix = produce(matrix, (draft) => {
      draft[index] = value;
    });
    setMatrix(newMatrix);
  };

  const resetMatrix = () => {
    setMatrix(["", "", "", "", "", ""]);
  };

  return {
    resetMatrix,
    setMatrixValue,
    matrix,
    errors,
    translationMatrix: getTranslationMatrix(matrix) as TranslationMatrix,
    setTranslationMatrix: (tm: TranslationMatrix) => {
      if (!tm) {
        setMatrix(["", "", "", "", "", ""]);
        return;
      }
      setMatrix(tm.map((v) => `${v}`) as MatrixInput);
    },
    isValidMatrixInput: isValidInput(matrix),
  };
};
